import "../servise.scss";

const ServiseFooter = () => {
  return (

          <div className="servise-block servise-block--final servise_footer">
            <div className="servise_footer-item">
                <h2>Dlaczego warto?</h2>
                <section>
                <div>
                    <h3>Atuty PRO MOTO</h3>
                    <ul>
                    <li>140 + opinii Google</li>
                    <li>Jasna wycena</li>
                    <li>Markowe części</li>
                    <li>Terminowość</li>
                    </ul>
                </div>
                <div>
                    <h3>Korzyść dla Ciebie</h3>
                    <ul>
                        <li>Zaufany serwis przez społeczność</li>
                        <li>Znasz cenę przed rozpoczęciem napraw</li>
                        <li>Trwałość i bezpieczeństwo w codziennej jeździe</li>
                        <li>Odbierasz sprzęt gotowy na czas</li>
                    </ul>
                </div>
                </section>
            </div>
            <div  className="servise_footer-item">
                <h2>Jak wygląda serwis?</h2>
                <ol>
                    <li><strong>Rezerwacja online lub telefonicznie</strong></li>
                    <li><strong>Diagnoza na miejscu</strong> i omówienie zakresu prac</li>
                    <li><strong>Kosztorys do akceptacji</strong> – zero ukrytych opłat</li>
                    <li><strong>Naprawy mechaniczne</strong> zgodnie z procedurą producenta</li>
                    <li><strong>Odbiór lub transport</strong> pod wskazany adres (usługa płatna – zapytaj o szczegóły)</li>
                </ol>
            </div>
            <div  className="servise_footer-item">
                <h2>Umów wizytę</h2>
                <p>Zadzwoń <strong>535 744 816</strong> lub odwiedź nas przy <strong>ul. Dworcowa 11, Mrowino </strong>– a my zadbamy, by Twoja jazda była szybka, tania i bezpieczna.</p>
            </div>


          </div>
  );
};

export default ServiseFooter;
